import { memo } from 'react';

import { WorkspaceAgentChangePreviewPill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentChangePreviewPill';
import { WorkspaceAgentPendingPill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPendingPill';
import { WorkspaceAgentUnavailablePill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentUnavailablePill';
import { usePrivateWorkspaceAgentHydratedArtifactPill } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentHydratedArtifactPill';
import { type ChangePreviewPill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

export type PrivateWorkspaceAgentChangePreviewPillChipProps = {
  isStreaming: boolean;
  pill: ChangePreviewPill;
};

export const PrivateWorkspaceAgentChangePreviewPillChip = memo(
  ({ isStreaming, pill }: PrivateWorkspaceAgentChangePreviewPillChipProps) => {
    const {
      inViewRef,
      isPending,
      isUnavailable,
      pill: hydrated,
    } = usePrivateWorkspaceAgentHydratedArtifactPill({
      isStreaming,
      pill,
    });

    if (isPending) {
      return (
        <div className="w-full" ref={inViewRef}>
          <WorkspaceAgentPendingPill label="Change preview" />
        </div>
      );
    }

    if (isUnavailable || hydrated.type !== 'changePreview') {
      return (
        <div className="w-full" ref={inViewRef}>
          <WorkspaceAgentUnavailablePill kind="reference" referenceId={pill.id} />
        </div>
      );
    }

    return <WorkspaceAgentChangePreviewPill pill={hydrated} />;
  },
);

PrivateWorkspaceAgentChangePreviewPillChip.displayName = 'PrivateWorkspaceAgentChangePreviewPillChip';
